// extracted by mini-css-extract-plugin
export default {"section":"As-z","sectionTitle":"Bs-z","fieldWrapper":"Cs-z","formField":"Ds-z","disabled":"Es-z","formLabel":"Fs-z"};